import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  container: {
    padding: "0",
    width: "100%",
    margin: 0,
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    rowGap: "4px",
    width: "100%",
    height: "250px",
    padding: "5%",
    borderRadius: 10,
    color: "white",
    backgroundColor: "#eeeffb !important",
  },
  //   infoCard: {
  //       display: 'flex',
  //       flexDirection: 'column',
  //       textAlign: 'center',
  //   }
});
